/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Show_At_DoorInputs */

const en_label_show_at_door = /** @type {(inputs: Label_Show_At_DoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show at the door`)
};

const es_label_show_at_door = /** @type {(inputs: Label_Show_At_DoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar en la puerta`)
};

const fr_label_show_at_door = /** @type {(inputs: Label_Show_At_DoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À présenter à l'entrée`)
};

const de_label_show_at_door = /** @type {(inputs: Label_Show_At_DoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An der Tür vorzeigen`)
};

const id_label_show_at_door = /** @type {(inputs: Label_Show_At_DoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tunjukkan di pintu masuk`)
};

/** @type {(inputs: Label_Show_At_DoorInputs) => LocalizedString} */
const ja_label_show_at_door = en_label_show_at_door;

/** @type {(inputs: Label_Show_At_DoorInputs) => LocalizedString} */
const zh_label_show_at_door = en_label_show_at_door;

/** @type {(inputs: Label_Show_At_DoorInputs) => LocalizedString} */
const ar_label_show_at_door = en_label_show_at_door;

/** @type {(inputs: Label_Show_At_DoorInputs) => LocalizedString} */
const it_label_show_at_door = en_label_show_at_door;

/** @type {(inputs: Label_Show_At_DoorInputs) => LocalizedString} */
const ru_label_show_at_door = en_label_show_at_door;

/** @type {(inputs: Label_Show_At_DoorInputs) => LocalizedString} */
const pt_label_show_at_door = en_label_show_at_door;

/** @type {(inputs: Label_Show_At_DoorInputs) => LocalizedString} */
const ko_label_show_at_door = en_label_show_at_door;

/**
* | output |
* | --- |
* | "Show at the door" |
*
* @param {Label_Show_At_DoorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_show_at_door = /** @type {((inputs?: Label_Show_At_DoorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Show_At_DoorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_show_at_door(inputs)
	if (locale === "es") return es_label_show_at_door(inputs)
	if (locale === "fr") return fr_label_show_at_door(inputs)
	if (locale === "de") return de_label_show_at_door(inputs)
	if (locale === "ja") return ja_label_show_at_door(inputs)
	if (locale === "zh") return zh_label_show_at_door(inputs)
	if (locale === "ar") return ar_label_show_at_door(inputs)
	if (locale === "id") return id_label_show_at_door(inputs)
	if (locale === "it") return it_label_show_at_door(inputs)
	if (locale === "ru") return ru_label_show_at_door(inputs)
	if (locale === "pt") return pt_label_show_at_door(inputs)
	return ko_label_show_at_door(inputs)
});